import { useMemo } from 'react';
import qs from 'query-string';
import { useQueryString } from '~/react-hooks/use-query-string';
import { useHistory } from 'react-router';

export enum MyLibraryTab {
  All = 'all',
  ScreenRecordings = 'screen-recordings',
  Uploaded = 'uploaded',
  Responses = 'responses',
}

export const getLinkByTab = (tab: MyLibraryTab) =>
  `/my-library?${qs.stringify({ tab })}`;

export function useLibraryTabs() {
  const { tab } = useQueryString<{ tab: MyLibraryTab }>();
  const history = useHistory();

  const { activeTabKey, activeTabName, tabsMap } = useMemo<{
    activeTabKey: number;
    activeTabName: MyLibraryTab;
    tabsMap: MyLibraryTab[];
  }>(() => {
    const { tabs, tabsMap } = Object.values(MyLibraryTab).reduce<{
      tabs: Record<string, number>;
      tabsMap: MyLibraryTab[];
    }>(
      ({ tabs, tabsMap }, value, index) => {
        return {
          tabs: {
            ...tabs,
            [value]: index,
          },
          tabsMap: [...tabsMap, value],
        };
      },
      { tabs: {}, tabsMap: [] }
    );

    return {
      activeTabKey: tab !== undefined ? tabs[tab] : 0,
      activeTabName: tab ?? MyLibraryTab.All,
      tabsMap,
    };
  }, [tab]);

  const redirectToUploadedTab = () => {
    const uploadedTabLink = getLinkByTab(MyLibraryTab.Uploaded);
    history.push(uploadedTabLink);
  };

  return { activeTabKey, activeTabName, tabsMap, redirectToUploadedTab };
}
